import { render, staticRenderFns } from "./submit-btn.vue?vue&type=template&id=740d8bae&scoped=true&"
import script from "./submit-btn.vue?vue&type=script&lang=js&"
export * from "./submit-btn.vue?vue&type=script&lang=js&"
import style0 from "./submit-btn.vue?vue&type=style&index=0&id=740d8bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d8bae",
  null
  
)

export default component.exports